import { empApi } from "./client";

// =============================================================
// API Đánh giá cá nhân (KPI kinh doanh) - FEv1 cổng nhân viên.
// Khớp endpoint app (backend-v1 proxy tới dịch vụ document/MSH sync).
// employeeCode/quyền lấy từ token ở BE, FE không truyền.
// =============================================================
const BASE = "/document/api/v2/msh/evaluations/sale-kpis/monthly";

// Danh sách đánh giá theo năm của nhân viên đăng nhập -> MyMonthlyEvaluation[]
export const getMyYearlyEvaluationsApi = (year) =>
  empApi.get(`${BASE}/my-yearly`, { year });

// Chi tiết KPI theo tháng/năm của nhân viên -> StatisticalReportEmployeeInfo
export const getMyKpiDetailApi = ({ month, year, code }) =>
  empApi.get(`${BASE}/detail`, { month, year, code });

// Xác nhận đánh giá của tháng
export const confirmMyEvaluationApi = ({ month, year }) =>
  empApi.patch(`${BASE}/confirm`, { month, year });
